export default function () {
  return {
    current: {
      id: '',
      name: '',
      acronym: '',
      parent: null,
      resources: []
    },
    update: {
      id: '',
      name: '',
      acronym: '',
      parent: null
    },
    list: []
  }
}
